import React, { Component } from 'react';
import HatePdf from './HatePdf';

export function UmairHatePdf() {
    return (
        <>
            <HatePdf/>
        </>
    )
}